"use strict";
/* browser-based implementation of errorinject.ts.  See ../package.json */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnv = getEnv;
function getEnv(_varName) {
    return undefined;
}
//# sourceMappingURL=errorInject-browser.js.map